var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.75H0.75C0.46875 0.75 0.25 1 0.25 1.25V2.75C0.25 3.03125 0.46875 3.25 0.75 3.25H2.25C2.5 3.25 2.75 3.03125 2.75 2.75V1.25C2.75 1 2.5 0.75 2.25 0.75ZM2.25 5.75H0.75C0.46875 5.75 0.25 6 0.25 6.25V7.75C0.25 8.03125 0.46875 8.25 0.75 8.25H2.25C2.5 8.25 2.75 8.03125 2.75 7.75V6.25C2.75 6 2.5 5.75 2.25 5.75ZM2.25 10.75H0.75C0.46875 10.75 0.25 11 0.25 11.25V12.75C0.25 13.0312 0.46875 13.25 0.75 13.25H2.25C2.5 13.25 2.75 13.0312 2.75 12.75V11.25C2.75 11 2.5 10.75 2.25 10.75ZM15.25 11.5H4.75C4.59375 11.5 4.5 11.625 4.5 11.75V12.25C4.5 12.4062 4.59375 12.5 4.75 12.5H15.25C15.375 12.5 15.5 12.4062 15.5 12.25V11.75C15.5 11.625 15.375 11.5 15.25 11.5ZM15.25 1.5H4.75C4.59375 1.5 4.5 1.625 4.5 1.75V2.25C4.5 2.40625 4.59375 2.5 4.75 2.5H15.25C15.375 2.5 15.5 2.40625 15.5 2.25V1.75C15.5 1.625 15.375 1.5 15.25 1.5ZM15.25 6.5H4.75C4.59375 6.5 4.5 6.625 4.5 6.75V7.25C4.5 7.40625 4.59375 7.5 4.75 7.5H15.25C15.375 7.5 15.5 7.40625 15.5 7.25V6.75C15.5 6.625 15.375 6.5 15.25 6.5Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.58d73b59.svg";
export { ForwardRef as ReactComponent };